import { CheckboxModel } from '../../../model/checkbox.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ion-common-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {

  @Input() selectedValue = '';
  @Input() itens: CheckboxModel[];
  @Output() changeCheckbox = new EventEmitter<CheckboxModel[]>();
  @Input() textSearch: string;


  changeValue(){
    const filterItens = this.itens.filter((item: CheckboxModel) => item.checked === true);
    this.changeCheckbox.emit(filterItens);
  }

}
